"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
const Langyan_1 = require("../Langyan");
const ProtocolConstant_1 = require("../../Protocol/ProtocolConstant");
class IceLink2Utils {
    /**
     *
     *
     * @private
     * @static
     * @param {fm.icelink.baseLinkArgs} e
     * @returns {string}
     * @memberof Langyan
     */
    static GenerateLinkRecordDetail(e) {
        const peerClient = e.getPeerClient();
        if (!peerClient)
            return "No peer client in link";
        const peerBindings = e.getPeerClient().getBoundRecords();
        if (!peerBindings)
            return "No bound record in link";
        let linkRecordDetail = "";
        for (const r in peerBindings) {
            linkRecordDetail += `${r}, ${peerBindings[r] ? peerBindings[r] : ""}`;
        }
        return linkRecordDetail;
    }
    /**
     *
     *
     * @private
     * @static
     * @param {fm.icelink.baseLinkArgs} e
     * @returns {string}
     * @memberof Langyan
     */
    static GenerateLinkArgsMessage(e) {
        return "";
        //return `Link=${e.getLink().getId()} to peer=${IceLink2Utils.GetPeerName(e)}, peerId=${e.getPeerId()}, peerState=${IceLink2Utils.ConvertPeerStateToString(e.getPeerState())}`;
    }
    static ConvertPeerStateToString(peerState) {
        if (!peerState)
            return '';
        let peerStateStr = '';
        for (const item in peerState) {
            peerStateStr += `[key=${item}, value=${peerState[item].getValueJson()}]`;
        }
        return peerStateStr;
    }
    /**
     *
     *
     * @private
     * @static
     * @param {fm.icelink.baseLinkArgs} e
     * @returns {string}
     * @memberof Langyan
     */
    static GetPeerName(e) {
        const peerBoundRecords = e.getPeerClient().getBoundRecords();
        return IceLink2Utils.GetPeerNameFromBoundRecords(peerBoundRecords);
    }
    static GetPeerNameFromBoundRecords(boundRecords) {
        var user = IceLink2Utils.GetPeer(boundRecords);
        return user != null ? user.userName : '';
    }
    /**
     *
     *
     * @static
     * @param {fm.icelink.baseLinkArgs} e
     * @returns {Tuple2<string, string>}
     * @memberof IceLink2Utils
     */
    static GetPeerIdName(e) {
        const peerBoundRecords = e.getPeerClient().getBoundRecords();
        if (!peerBoundRecords)
            return TypeScriptUtils_1.NewTuple2('', '');
        const user = IceLink2Utils.GetPeer(peerBoundRecords);
        if (user)
            return TypeScriptUtils_1.NewTuple2(user.userId, user.userName);
        else
            return TypeScriptUtils_1.NewTuple2('', '');
    }
    static GetPeer(boundRecords) {
        if (!boundRecords)
            return Langyan_1.LangyanUser.INVALID_LANGYAN_USER;
        const userRecord = boundRecords[ProtocolConstant_1.RTC_BINDING_LANGYAN_USER_KEY_NAME];
        if (!userRecord)
            return Langyan_1.LangyanUser.INVALID_LANGYAN_USER;
        const user = JSON.parse(userRecord.getValueJson());
        const langyanUser = new Langyan_1.LangyanUser(user);
        return langyanUser;
    }
}
exports.IceLink2Utils = IceLink2Utils;
//# sourceMappingURL=IceLink2Utils.js.map